import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "field-radiobutton p-mt-2"
}
const _hoisted_2 = ["for"]

import { computed } from "vue";
import { useDocuments } from "@/graphql/document/documents";
import { useRemoveDocument } from "@/graphql/document/remove.document";
import DocumentPrinter from "@/components/document/DocumentPrinter.vue";
import { Document } from "@/graphql/types";
import DocumentMovements from "@/components/document/DocumentMovements.vue";
import { CONSTANTS } from "@/graphql/utils/utils";
import { useStockPermissions } from "@/hooks/permissions/useStockPermission";


export default /*#__PURE__*/_defineComponent({
  __name: 'Document',
  setup(__props) {

const rowsPerPageOptions = CONSTANTS.rowsPerPageOptions;
const {
  input,
  document,
  loading,
  selected,
  setDocument,
  print,
  clearFilter,
  filters,
  movements,
} = useDocuments();
const { removeDocumentLoading, removeDocument } = useRemoveDocument();
const { canDelete } = useStockPermissions();

const cannotDelete = computed(() => !canDelete || removeDocumentLoading.value);

const onPrint = (row: Document) => {
  selected.value = row;
  print.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(selected) || _unref(print))
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 0,
          class: "card p-shadow-0 p-datatable-sm",
          value: _unref(document).items,
          responsiveLayout: "scroll",
          paginator: false,
          "show-gridlines": "",
          style: {"max-height":"calc(100vh - 130px)"},
          "data-key": "id",
          rowHover: false,
          filters: _unref(filters),
          "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_isRef(filters) ? (filters).value = $event : null)),
          filterDisplay: "menu",
          selection: _unref(selected)
        }, {
          header: _withCtx(() => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-filter-slash",
              label: _ctx.$t('clear'),
              class: "p-button-outlined",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(clearFilter)()))
            }, null, 8, ["label"])
          ]),
          empty: _withCtx(() => [
            _createTextVNode("Aucun document")
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_Paginator, {
              onPage: _cache[1] || (_cache[1] = ($event: any) => (_unref(input).page = $event.page + 1)),
              "rows-per-page-options": _unref(rowsPerPageOptions),
              rows: _unref(input).limit,
              "onUpdate:rows": _cache[2] || (_cache[2] = ($event: any) => ((_unref(input).limit) = $event)),
              totalRecords: _unref(document).meta.totalItems
            }, null, 8, ["rows-per-page-options", "rows", "totalRecords"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "createdAt",
              "show-add-button": false,
              showFilterOperator: false,
              header: _ctx.$t('date'),
              dataType: "date",
              style: {"min-width":"8rem"},
              "filter-field": "createdAt",
              sortable: true,
              "sort-field": "createdAt"
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_ctx.$d(data.createdAt, "long")), 1)
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_Calendar, {
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  dateFormat: _ctx.$t('format.calendarDate'),
                  placeholder: _ctx.$t('format.date'),
                  "year-navigator": true
                }, null, 8, ["modelValue", "onUpdate:modelValue", "dateFormat", "placeholder"])
              ]),
              filterclear: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-times",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-warning p-mr-1",
                  label: _ctx.$t('prime.clear')
                }, null, 8, ["onClick", "label"])
              ]),
              filterapply: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-search",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-success",
                  label: _ctx.$t('search')
                }, null, 8, ["onClick", "label"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "number",
              header: _ctx.$t('document.number'),
              sortable: true,
              "sort-field": "number",
              "show-add-button": false,
              showFilterOperator: false,
              "filter-field": "quantity",
              dataType: "numeric"
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_NumberFormatter, {
                  value: data.number
                }, null, 8, ["value"])
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_InputNumber, {
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  "max-fraction-digits": 20,
                  min: 0,
                  mode: "decimal"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              filterclear: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-warning p-button-sm",
                  label: _ctx.$t('prime.clear')
                }, null, 8, ["onClick", "label"])
              ]),
              filterapply: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  label: _ctx.$t('search'),
                  type: "button",
                  icon: "pi pi-search",
                  class: "p-button-sm",
                  onClick: ($event: any) => (filterCallback())
                }, null, 8, ["label", "onClick"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              "show-filter-match-modes": false,
              filterField: "type",
              field: "type",
              "show-add-button": false,
              "show-filter-operator": false,
              style: {"min-width":"150px"},
              header: _ctx.$t('document.type'),
              dataType: "numeric",
              sortable: true
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_ctx.$tm("document.types")[data.type]), 1)
              ]),
              filter: _withCtx(({ filterModel, filterCallback }) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('document.types'), (type, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (index !== 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                          _createVNode(_component_Checkbox, {
                            id: `type${index}`,
                            name: "type",
                            value: index,
                            modelValue: filterModel.value,
                            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                            onChange: ($event: any) => (filterCallback())
                          }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue", "onChange"]),
                          _createElementVNode("label", {
                            class: "p-ml-2",
                            for: `type${index}`
                          }, _toDisplayString(type), 9, _hoisted_2)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              filterclear: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-times",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-warning p-mr-1",
                  label: _ctx.$t('prime.clear')
                }, null, 8, ["onClick", "label"])
              ]),
              filterapply: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-search",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-success",
                  label: _ctx.$t('search')
                }, null, 8, ["onClick", "label"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              header: _ctx.$t('document.productCount'),
              field: "productCount",
              sortable: true,
              "sort-field": "productCount",
              "show-add-button": false,
              showFilterOperator: false,
              "filter-field": "productCount",
              dataType: "numeric"
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_NumberFormatter, {
                  value: data.productCount
                }, null, 8, ["value"])
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_InputNumber, {
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  "max-fraction-digits": 20,
                  min: 0,
                  mode: "decimal"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              filterclear: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-warning p-button-sm",
                  label: _ctx.$t('prime.clear')
                }, null, 8, ["onClick", "label"])
              ]),
              filterapply: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  label: _ctx.$t('search'),
                  type: "button",
                  icon: "pi pi-search",
                  class: "p-button-sm",
                  onClick: ($event: any) => (filterCallback())
                }, null, 8, ["label", "onClick"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              header: _ctx.$t('controls'),
              style: {"max-width":"100px"}
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_Button, {
                  onClick: ($event: any) => (onPrint(data)),
                  icon: "pi pi-print",
                  class: "p-button-rounded p-button-success"
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  class: _normalizeClass(["p-button-rounded p-mx-3", { 'p-button-warning': !!data.deletedAt }]),
                  icon: "pi pi-eye",
                  onClick: ($event: any) => (_unref(setDocument)(data))
                }, null, 8, ["class", "onClick"]),
                (!data.deletedAt)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      onClick: ($event: any) => (_unref(removeDocument)(data.id)),
                      disabled: cannotDelete.value,
                      icon: "pi pi-trash",
                      class: "p-button-rounded p-button-danger"
                    }, null, 8, ["onClick", "disabled"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        }, 8, ["value", "filters", "selection"]))
      : (_openBlock(), _createBlock(DocumentMovements, {
          key: 1,
          selected: _unref(selected),
          onSetDocument: _cache[4] || (_cache[4] = ($event: any) => (_unref(setDocument)(null))),
          movements: _unref(movements)
        }, null, 8, ["selected", "movements"])),
    (_unref(print))
      ? (_openBlock(), _createBlock(DocumentPrinter, {
          key: 2,
          movements: (_unref(movements) as any[]),
          modelValue: _unref(print),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(print) ? (print).value = $event : null)),
          selected: _unref(selected),
          "onUpdate:selected": _cache[6] || (_cache[6] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null))
        }, null, 8, ["movements", "modelValue", "selected"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})